import React, { useState } from "react";

import Footerphone from "../assets/footerphone.png";
import Logo from "../assets/logo.jpg";
import playstore from "../assets/playstore.png";
import appstore from "../assets/applestore.png";

// Terms & Conditions document
import TermsAndConditions from "../assets/Privacy-Policy.pdf";

import "../Styles/Footer.css";

import pic1 from "../assets/linkedin.png";
import pic2 from "../assets/facebook.png";
import pic3 from "../assets/twitter.png";
import pic4 from "../assets/instagram.png";
import pic5 from "../assets/youtube.png";

function Footer2() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteEmail, setDeleteEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const openDeleteModal = (e) => {
    e.preventDefault();
    setShowDeleteModal(true);
    setSubmitted(false);
    setDeleteEmail("");
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSubmitted(false);
    setDeleteEmail("");
  };

  const handleDeleteSubmit = (e) => {
    e.preventDefault();

    if (!deleteEmail) return;

    // Opens the user's email client with a pre-filled deletion request.
    // Replace this logic with an API call if you have a backend endpoint.
    window.location.href =
      "mailto:info@nhrclub.com?subject=Account%20Deletion%20Request&body=Please%20delete%20the%20account%20associated%20with%20this%20email%3A%20" +
      encodeURIComponent(deleteEmail);

    setSubmitted(true);
  };

  return (
    <footer className="nhrc-footer" id="contact">

      {/* =========================================
          MAIN FOOTER CONTENT
      ========================================= */}
      <div className="container-fluid nhrc-footer-main">
        <div className="row align-items-center">

          {/* =====================================
              LOGO + APP SECTION
          ===================================== */}
          <div className="col-md-5 nhrc-footer-app">
            {/* Company Logo */}
            <div className="nhrc-footer-logo-wrapper">
              <img src={Logo} alt="NHRC Logo" className="footer-logo" />
            </div>

            {/* App Download Content */}
            <div className="nhrc-app-content">
              <h3 className="nhrc-app-title">Download NHRC App</h3>

              <p className="nhrc-app-subtitle">
                Now available on Play Store &amp; App Store
              </p>

              {/* App Store Buttons */}
              <div className="nhrc-store-buttons">
                <a href="#!" aria-label="Download from Google Play">
                  <img src={playstore} alt="Google Play Store" className="footer-store" />
                </a>

                <a href="#!" aria-label="Download from Apple App Store">
                  <img src={appstore} alt="Apple App Store" className="footer-store" />
                </a>
              </div>

              {/* Social Media */}
              <div className="nhrc-social-icons">
                <a href="#!" aria-label="LinkedIn">
                  <img src={pic1} alt="LinkedIn" className="icon-footer" />
                </a>

                <a href="#!" aria-label="Facebook">
                  <img src={pic2} alt="Facebook" className="icon-footer" />
                </a>

                <a href="#!" aria-label="Twitter">
                  <img src={pic3} alt="Twitter" className="icon-footer" />
                </a>

                <a href="#!" aria-label="Instagram">
                  <img src={pic4} alt="Instagram" className="icon-footer" />
                </a>

                <a href="#!" aria-label="YouTube">
                  <img src={pic5} alt="YouTube" className="icon-footer" />
                </a>
              </div>
            </div>
          </div>

          {/* =====================================
              PHONE IMAGE
          ===================================== */}
          <div className="col-md-2 nhrc-footer-phone-section">
            <img
              src={Footerphone}
              className="footer-phone"
              alt="NHRC Mobile Application"
            />
          </div>

          {/* =====================================
              ADDRESS SECTION
          ===================================== */}
          <div className="col-md-5 nhrc-footer-address">
            <h4 className="address-let">Corporate Address:</h4>

            <p className="address-let1">
              S/22, HOG Market, Adjacent To Prabhat Kiran
              Building, Rajendra Place, New Delhi,
              Delhi - 110005
            </p>

            <h4 className="address-let">Land Mark:</h4>

            <p className="address-let1">
              Prabhat Kiran Building, Rajendra Place,
              New Delhi, Delhi
            </p>

            {/* Phone - Same Line */}
            <div className="footer-contact-row">
              <span className="footer-contact-label">Phone Number:</span>

              <a href="tel:+919963377035" className="footer-contact-value">
                +91 99633 77035
              </a>
            </div>

            {/* Email - Same Line */}
            <div className="footer-contact-row">
              <span className="footer-contact-label">E-mail Address:</span>

              <a
                href="mailto:info@nhrclub.com"
                className="footer-contact-value footer-email"
              >
                info@nhrclub.com
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* =========================================
          FOOTER BOTTOM
      ========================================= */}
      <div className="nhrc-footer-bottom">
        <div className="nhrc-footer-bottom-content">
          <p className="nhrc-copyright">
            © 2026 NHRC. All Rights Reserved.
          </p>

          {/* Terms & Conditions / Delete Account Links */}
          <div className="nhrc-footer-links">
            <a
              href={TermsAndConditions}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-terms-anchor"
            >
              Terms &amp; Conditions
            </a>

            <span className="nhrc-footer-link-divider">|</span>

            <a
              href="#!"
              onClick={openDeleteModal}
              className="footer-terms-anchor"
            >
              Delete Your Account
            </a>
          </div>

          <p className="nhrc-developed">
            Designed &amp; Developed by{" "}
            <strong>YSK Info Tech Pvt. Ltd.</strong>
          </p>
        </div>
      </div>

      {/* =========================================
          DELETE ACCOUNT MODAL
      ========================================= */}
      {showDeleteModal && (
        <div className="nhrc-modal-overlay" onClick={closeDeleteModal}>
          <div
            className="nhrc-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="nhrc-modal-close"
              onClick={closeDeleteModal}
              aria-label="Close"
            >
              &times;
            </button>

            {!submitted ? (
              <>
                <h3 className="nhrc-modal-title">Delete Your Account</h3>
                <p className="nhrc-modal-subtitle">
                  Enter the email address linked to your account. We'll
                  process your deletion request from there.
                </p>

                <form onSubmit={handleDeleteSubmit} className="nhrc-modal-form">
                  <input
                    type="email"
                    required
                    placeholder="Enter your email"
                    value={deleteEmail}
                    onChange={(e) => setDeleteEmail(e.target.value)}
                    className="nhrc-modal-input"
                  />

                  <div className="nhrc-modal-actions">
                    <button
                      type="button"
                      className="nhrc-modal-btn nhrc-modal-btn-cancel"
                      onClick={closeDeleteModal}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="nhrc-modal-btn nhrc-modal-btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div className="nhrc-modal-success">
                <h3 className="nhrc-modal-title">Request Sent</h3>
                <p className="nhrc-modal-subtitle">
                  Your account deletion request for{" "}
                  <strong>{deleteEmail}</strong> has been submitted. Our team
                  will get in touch shortly.
                </p>

                <button
                  className="nhrc-modal-btn nhrc-modal-btn-submit"
                  onClick={closeDeleteModal}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}

    </footer>
  );
}

export default Footer2;